import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import SignIn from "../Pages/Auth/SignIn";
import PrivateRoutes from "./PrivateRoutes";
import VisualLogin2 from "../Components/Pages/Others/Authentication/VisualLogin2";
import ForgetPassword from "../Components/Pages/Others/Authentication/ForgetPassword";
import RegisterWizard from "../Components/Pages/Others/Authentication/RegisterWizard";
import { getCurrentUser } from "../services/auth";
import LoginByToken from "./LoginByToken";
import PrintLayout from "./PrintLayout";
import CloseReports from "../Pages/Reports/CloseReport";
import PrintEODReports from "../Pages/Reports/Print/EOD";
import EODSummaryPrint from "../Pages/Reports/Print/EODSummary";
import EODByCategoryPrint from "../Pages/Reports/Print/EODCategory";
import EODByPayTypesPrint from "../Pages/Reports/Print/EODPaytypes";
import POSInvoice from "../Pages/POS/Print/Invoice";
import LabelPrint from "../Pages/POS/Print/Label";

export default function Routers() {
  const login = getCurrentUser();

  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        {login ? (
          <>
            <Route
              path={`${process.env.PUBLIC_URL}`}
              element={<Navigate to={`${process.env.PUBLIC_URL}/pos`} />}
            />
            <Route
              path={`/`}
              element={<Navigate to={`${process.env.PUBLIC_URL}/pos`} />}
            />
          </>
        ) : (
          ""
        )}

        {/* ✅ Public Print View Route */}
        <Route
          path="/print/reports/close"
          element={
            <PrintLayout>
              <CloseReports isPrint={true} />
            </PrintLayout>
          }
        />
        <Route
          path="/print/reports/eod"
          element={
            <PrintLayout>
              <PrintEODReports />
            </PrintLayout>
          }
        />
        <Route
          path="/print/reports/eod-summary/:register_id"
          element={
            <PrintLayout>
              <EODSummaryPrint />
            </PrintLayout>
          }
        />
        <Route
          path="/print/reports/eod-category/:register_id"
          element={
            <PrintLayout>
              <EODByPayTypesPrint />
            </PrintLayout>
          }
        />

        {/* ✅ App Routes with Layout and Auth */}
        <Route path={"/"} element={<PrivateRoutes />}>
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>

        {/* ✅ Auth Routes */}
        <Route
          path={`${process.env.PUBLIC_URL}/login`}
          element={<VisualLogin2 />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/register`}
          element={<RegisterWizard />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/auth/forget_password`}
          element={<ForgetPassword />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/auth/token`}
          element={<LoginByToken />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pos/invoice`}
          element={<POSInvoice />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/print/label`}
          element={<LabelPrint />}
        />
      </Routes>
    </BrowserRouter>
  );
}
